import { inject, Pipe, PipeTransform } from '@angular/core';

import { LanguageService } from 'app/services';

@Pipe({
    name: 'stbyCountryName',
})
export class CountryNamePipe implements PipeTransform {
    private readonly languageService = inject(LanguageService);

    transform(abbr = 'eng', language = 'en'): string {
        return this.languageService.getCountryNameFromAbbr(abbr, language);
    }
}
